(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  const root = document.documentElement;
  const marqueeElementsDisplayed = getComputedStyle(root).getPropertyValue("--marquee-elements-displayed");
  const marqueeContent = document.querySelector("ul.marquee-content");
  
  root.style.setProperty("--marquee-elements", marqueeContent.children.length);
  
  for(let i=0; i<marqueeElementsDisplayed; i++) {
    marqueeContent.appendChild(marqueeContent.children[i].cloneNode(true));
  }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizing-calculator"] && !Shopify.designMode) return;
  try {
    
  // Select the first carousel-cell with any given title
var carouselCells = document.getElementsByClassName("carousel-cell");
var titleSet = new Set();

for (var i = 0; i < carouselCells.length; i++) {
  var currentTitle = carouselCells[i].getAttribute("data-title");

  if (titleSet.has(currentTitle)) {
    continue; // Skip if title has already been encountered
  }

  titleSet.add(currentTitle);
  carouselCells[i].classList.add("first-carousel-cell");
}
  
  // Function to initialize or destroy the carousel-nav based on window size
function toggleCarouselNav() {
  var windowWidth = window.innerWidth;

  if (windowWidth < 768) {
    // Initialize carousel-nav
    if (!flktyNav) {
      flktyNav = new Flickity('.carousel-nav', {
        asNavFor: '.carousel-main',
        contain: true,
        pageDots: false,
        freeScroll: true,
        prevNextButtons: false,
        wrapAround: true,
        cellAlign: false
      });
    }
  } else {
    // Destroy carousel-nav
    if (flktyNav) {
      flktyNav.destroy();
      flktyNav = null;
    }
  }

  // Reapply is-selected class to the active carousel-cell
  var selectedIndex = flktyMain.selectedIndex;
  var carouselNavCells = document.querySelectorAll('.carousel-nav .carousel-cell');
  carouselNavCells.forEach(function(cell, index) {
    if (index === selectedIndex) {
      cell.classList.add('is-nav-selected');
    } else {
      cell.classList.remove('is-nav-selected');
    }
  });
}

// Initialize carousel-main
var flktyMain = new Flickity('.carousel-main', {
  fade: true,
  draggable: false,
  prevNextButtons: false,
  pageDots: false,
  adaptiveHeight: true
});

// Initialize or destroy carousel-nav on page load
var flktyNav = null;
toggleCarouselNav();

// Attach event listener for window resize
window.addEventListener('resize', function() {
  // Debounce the function to avoid rapid execution during resizing
  clearTimeout(window.resizeTimer);
  window.resizeTimer = setTimeout(toggleCarouselNav, 250);
});


// Use carousel-nav's cells as buttons for carousel-main
var carouselNavCells = document.querySelectorAll('.carousel-nav .carousel-cell');
carouselNavCells.forEach(function(cell, index) {
  cell.addEventListener('click', function() {
    flktyMain.select(index);
    // Update is-nav-selected class on click
    carouselNavCells.forEach(function(navCell) {
      navCell.classList.remove('is-nav-selected');
    });
    cell.classList.add('is-nav-selected');
  });
});

  } catch(e) { console.error(e); }
})();
})();
